// extracted by mini-css-extract-plugin
export default {"iframeScrollWrapper":"styles__iframeScrollWrapper--2Sf5e","iframeContent":"styles__iframeContent--1dOlU","splashScreen":"styles__splashScreen--3k0k4","loadingWrapper":"styles__loadingWrapper--2R1gX"};
    if(module.hot) {
      // 1717856619507
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  